<template>
    <div class="app">
        <Header></Header>
      <div class="main ovf problem">
        <div class="bg-color">
          <router-link to="/xieyi" >《用户服务协议》</router-link>
          <router-link to="/yinsi">《隐私政策》</router-link>
          <router-link to="/guifan">《链接内容管理规范》</router-link>
          <router-link to="/help" style="padding-bottom: 15px;border-bottom: 2px solid #008DF2;color: #008DF2">《使用帮助》</router-link>
          <router-link to="/about" >《关于我们》</router-link>
        </div>
        <div class="user-console ovf gray-back">
          <div class="wrap ovf" >
            <div class="u-lef fl ovf bgw mt20">
              <div class="u-nav ovf">
                <h4 style="text-align: left;">功能说明</h4>
                <div class="nav-list ovf">
                  <ol class="ovf new-style" >
                    <li><a @click="go_page(1)"><span class="font-style">什么是短网址</span></a></li>
                    <li><a @click="go_page(2)"><span class="font-style">免费用户和VIP用户的区别</span></a></li>
                    <li><a @click="go_page(3)"><span class="font-style">天天短网址二维码的功能说明</span></a></li>
                    <li><a @click="go_page(4)"><span class="font-style">高级功能之访问密码设置说明</span></a></li>
                    <li><a @click="go_page(5)"><span class="font-style">高级功能之地区定位功能说明</span></a></li>
                    <li><a @click="go_page(6)"><span class="font-style">高级功能之设备定位功能说明</span></a></li>
                    <li><a @click="go_page(7)"><span class="font-style">高级功能之VIP专业报表功能说明</span></a></li>
                    <li><a @click="go_page(8)" ><span class="font-style">高级功能之替换原网址功能说明</span></a></li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="fr u-rig">
              <div class=" ovf bgw problem-style" id="problem1">
                <div class=" ovf ggf problem-title">
                  什么是短网址？为什么要选择45管理短网址一站式服务？
                </div>
                <div class="problem-small">
                  1.什么是短网址？
                </div>
                <div class="problem-text">
                  <ol>
                    <li>很多人有疑问，短网址的存在到底有什么意义呢？这个问题在移动互联网时代还未开始的时候，真的很难回答，但是如今，我相信没有人不知道短网址存在的重要性了。因为很多很多人都在日常生活中能见到短链接。据不完全统计，目前移动流量已经远远超越了PC流量，不得不承认现在是移动互联网的时代。我身边很多朋友告诉我，他们基本上几个月才会用一次电脑，有的甚至一年都没有用过PC电脑。电脑开机率越来越低，是因为随着移动互联网时代的到来，生活中越来越多的问题可以直接用手机解决。甚至出现了很多新的名词：低头族。虽然这种说话带有点贬义，但是非常符合目前的现状。手机已经成了生活照必不可少的物品，但你离开家的时候，都会下意识的摸摸口袋是否带了手机，手机是否有电等等。</li>
                    <li>移动互联网时代虽然已经到来，移动设备主宰着我们的生活，但是电池技术的局限，很多移动设备的屏幕不可能做的很大。在有限的屏幕内，为了提升用户体验必须要缩短网址，这个时候，短网址就成了不可或缺的重要手段。</li>
                  </ol>
                </div>
                <div class="problem-small">
                  2.为什么要选择45管理短网址一站式服务？
                </div>
                <div class="problem-text">
                  <ol>
                    <li>随着互联网信息业务的快速发展，企业对数据精细化运营的要求也越来越高，短网址生成的需求日益多样化。短网址除了单条生成生成短网址，二维码下载外，是否还有其他短网址生成方式和链接生成后数据的处理？答案当然是肯定的。</li>
                    <li>45管理短网址一站式服务平台根据客户的需求，不仅可以支持单条生成短网址、二维码下载外还支持批量转换，历史转换记录，一次生成，安全稳定，永久有效。 免费统计pv、uv、ip，pc识别统计，移动设备识别统计，用户地区识别统计，专业的统计报表满足多维度的运营需求。可以替换已生成短网址的原链接，为短网址设置访问密码，针对不同地区、不同设备，一个链接有多个推广落地页。了解用户行为路径，优化核心转化路径，提高转化，把访客变成客户，把流量变成注册和购买。</li>
                  </ol>
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help3.png" style="height: auto;">
                </div>
              </div>
              <div class="fr ovf bgw problem-style" id="problem2" >
                <div class=" ovf ggf problem-title">
                  免费用户和VIP用户的区别。VIP用户享受哪些权益？
                </div>
                <div class="problem-small">
                  1.免费用户和VIP用户的区别。
                </div>
                <div class="problem-text">
                  <ol>
                    <li>免费用户和VIP用户的区别在于，在单条链接生成短链接不能满足企业需求，无法满足企业精细化运营的情况下。我们有提供的一部分增值服务以满足不同企业精细化运营的要求，使得企业不占用过多的运营资金，还能随时享受最新及最佳解决方案。</li>
                  </ol>
                </div>
                <div class="problem-small">
                  2.VIP用户享受哪些权益？
                </div>
                <div class="problem-text">
                  <ol>
                    <li>VIP用户不仅可以支持单条生成短网址、二维码下载外还支持批量转换，历史转换记录，一次生成，安全稳定，永久有效。 免费统计pv、uv、ip，pc识别统计，移动设备识别统计，用户地区识别统计，专业的统计报表满足多维度的运营需求。可以替换已生成短网址的原链接，为短网址设置访问密码，针对不同地区、不同设备，一个链接有多个推广落地页。了解用户行为路径，优化核心转化路径，提高转化，把访客变成客户，把流量变成注册和购买。 </li>
                  </ol>
                </div>
                <div class="problem-img">

                  <img src="../../assets/images/help4.png" style="height: auto;">
                </div>
              </div>
              <div class="fr ovf bgw problem-style" id="problem3" >
                <div class=" ovf ggf problem-title">
                  天天短网址二维码的功能说明。
                </div>
                <div class="problem-text">
                  <ol>
                    <li>一个连接地址如果的文字符号的状态下会非常复杂，辨识度和易用性也很差，那么如何操作才能得到一个相对简单的二维码呢？下面就介绍一下天天短网址二维码功能的说明。</li>
                  </ol>
                </div>
                <div class="problem-small">
                  1.首先打开浏览器地址栏中复制您想生成二维码的网址。
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help5.png" style="height: auto;">
                </div>
                <div class="problem-small">
                  2.在浏览器中搜索天天短网址www.ttdwz.cc,并将复制好的连接粘贴在文字框中。
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help6.png" style="height: auto;">
                </div>
                <div class="problem-small">
                  3.点击转换按钮,系统会自动生成短链接和二维码。
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help7.png" style="height: auto;">
                </div>
              </div>
              <div class="fr ovf bgw problem-style" id="problem4" >
                <div class=" ovf ggf problem-title">
                  高级功能之访问密码设置说明。
                </div>
                <div class="problem-text">
                  <ol>
                    <li>在分享链接的时候，很多企业有时候就会有这样的需求，我们有一部分链接只想给特定的人或设备访问，那该怎么办呢？无法知道很直观的知晓点击链接人的地区分类，设备分类，等精细化运营的数据，那该怎么办？根据大家的需求我们的高级功能也就应运而生了，在我们的高级功能里有访问密码，地区定位，设备定位，VIP专业报表，替换原网址等以满足各个群体的不同需求。</li>
                    <li>今天我们就来讲解一下，高级功能之访问密码设置的说明。</li>
                  </ol>
                </div>
                <div class="problem-small">
                  1.首先在浏览器中搜索天天短网址www.ttdwz.cc,点击登入。
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help1.png" style="height: auto;">
                </div>
                <div class="problem-small">
                  2.进入登入列表，点击左栏内的短网址列表（如没有您要用的链接，需先在首页先将长链接转换成短链接），然后点击您需要设置访问密码链接右边的高级功能，进入高级功能页面。
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help_mima2.png" style="height: auto;">
                </div>
                <div class="problem-small">
                  3.进入高级功能页面后，访问密码点击变成启用状态，然后设置密码并保存。
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help_mima.png" style="height: auto;">
                </div>
                <div class="problem-small">
                  4.访问密码到这里就完成了。之后想要访问这条链接输入之前设置的密码就可以了。
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help_mima4.png" style="height: auto;">
                </div>
              </div>
              <div class="fr ovf bgw problem-style" id="problem5" >
                <div class=" ovf ggf problem-title">
                  高级功能之地区定位功能说明。
                </div>
                <div class="problem-text">
                  <ol>
                    <li>在分享链接的时候，很多企业有时候就会有这样的需求，我们有一部分链接只想给特定的人或设备访问，那该怎么办呢？无法知道很直观的知晓点击链接人的地区分类，设备分类，等精细化运营的数据，那该怎么办？根据大家的需求我们的高级功能也就应运而生了，在我们的高级功能里有访问密码，地区定位，设备定位，VIP专业报表，替换原网址等以满足各个群体的不同需求。</li>
                    <li>今天我们就来讲解一下，高级功能之地区定位功能说明。</li>
                  </ol>
                </div>
                <div class="problem-small">
                  1.首先在浏览器中搜索天天短网址www.ttdwz.cc,点击登入。
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help1.png" style="height: auto;">
                </div>
                <div class="problem-small">
                  2.进入登入列表，点击左栏内的短网址列表（如没有您要用的链接，需先在首页先将长链接转换成短链接），然后点击您需要设置访问密码链接右边的高级功能，进入高级功能页面。
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help_sb1.png" style="height: auto;">
                </div>
                <div class="problem-small">
                  3.进入高级功能页面后，地区定位点击变成启用状态，然后选择地区。（如果您要在不同的地区显示不同页面，则可以使用相同的短网址将用户重定向到设置的链接。）
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help_sb3.png" style="height: auto;">
                </div>
                <div class="problem-small">
                  4.地区定位到这里就完成了。
                </div>

              </div>
              <div class="fr ovf bgw problem-style" id="problem6" >
                <div class=" ovf ggf problem-title">
                  高级功能之设备定位功能说明。
                </div>
                <div class="problem-text">
                  <ol>
                    <li>在分享链接的时候，很多企业有时候就会有这样的需求，我们有一部分链接只想给特定的人或设备访问，那该怎么办呢？无法知道很直观的知晓点击链接人的地区分类，设备分类，等精细化运营的数据，那该怎么办？根据大家的需求我们的高级功能也就应运而生了，在我们的高级功能里有访问密码，地区定位，设备定位，VIP专业报表，替换原网址等以满足各个群体的不同需求。</li>
                    <li>今天我们就来讲解一下，高级功能之设备定位功能说明。</li>
                  </ol>
                </div>
                <div class="problem-small">
                  1.首先在浏览器中搜索天天短网址www.ttdwz.cc,点击登入。
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help1.png" style="height: auto;">
                </div>
                <div class="problem-small">
                  2.进入登入列表，点击左栏内的短网址列表（如没有您要用的链接，需先在首页先将长链接转换成短链接），然后点击您需要设置访问密码链接右边的高级功能，进入高级功能页面。
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help_mima2.png" style="height: auto;">
                </div>
                <div class="problem-small">
                  3.进入高级功能页面后，设备定位点击变成启用状态，然后添加设备。（如果您要在不同的设备显示不同页面（例如Android、IOS等），则可以使用相同的短网址将用户重定向到设置的链接。）
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help_sb3.png" style="height: auto;">
                </div>
                <div class="problem-small">
                  4.设备定位到这里就完成了。
                </div>

              </div>
              <div class="fr ovf bgw problem-style" id="problem7" >
                <div class=" ovf ggf problem-title">
                  高级功能之VIP专业报表功能说明。
                </div>
                <div class="problem-text">
                  <ol>
                    <li>在分享链接的时候，很多企业有时候就会有这样的需求，我们有一部分链接只想给特定的人或设备访问，那该怎么办呢？无法知道很直观的知晓点击链接人的地区分类，设备分类，等精细化运营的数据，那该怎么办？根据大家的需求我们的高级功能也就应运而生了，在我们的高级功能里有访问密码，地区定位，设备定位，VIP专业报表，替换原网址等以满足各个群体的不同需求。</li>
                    <li>今天我们就来讲解一下，高级功能之VIP专业报表功能说明。</li>
                  </ol>
                </div>
                <div class="problem-small">
                  1.首先在浏览器中搜索天天短网址www.ttdwz.cc,点击登入。
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help1.png" style="height: auto;">
                </div>
                <div class="problem-small">
                  2.进入登入列表，点击左栏内的短网址列表（如没有您要用的链接，需先在首页先将长链接转换成短链接），然后点击您需要设置访问密码链接右边的数据统计，进入数据统计页面。
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help_tj1.png" style="height: auto;">
                </div>
                <div class="problem-small">
                  3.数据统计页面
                </div>
                <div class="problem-text">
                  <ol>
                    <li>访问数据:</li>
                    <li>pv访问量（Page View），即页面访问量，每打开一次页面PV计数+1，刷新页面也是。</li>
                    <li>UV访问数（Unique Visitor）指独立访客访问数，一台电脑终端为一个访客。</li>
                    <li>IP是IP访问数指独立IP访问数。</li>
                  </ol>
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help_tj2.png" style="height: auto;">
                </div>
                <div class="problem-text">
                  <ol>
                    <li>客户端数据统计:</li>
                  </ol>
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help_tj3.png" style="height: auto;">
                </div>
                <div class="problem-text">
                  <ol>
                    <li>访问者浏览器统计:</li>
                  </ol>
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help_tj4.png" style="height: auto;">
                </div>
                <div class="problem-text">
                  <ol>
                    <li>全国地图数据统计:</li>
                  </ol>
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help_tj6.png" style="height: auto;">
                </div>
                <div class="problem-text">
                  <ol>
                    <li>网络供应商统计:</li>
                  </ol>
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help_tj6.png" style="height: auto;">
                </div>
                <div class="problem-text">
                  <ol>
                    <li>访问记录明细:</li>
                  </ol>
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help_tj7.png" style="height: auto;">
                </div>
                <div class="problem-text">
                  <ol>
                    <li>高频访问IP名单前十:</li>
                  </ol>
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help_tj8.png" style="height: auto;">
                </div>
              </div>
              <div class="fr ovf bgw problem-style" id="problem8" >
                <div class=" ovf ggf problem-title">
                  高级功能之替换原网址功能说明。
                </div>
                <div class="problem-text">
                  <ol>
                    <li>在分享链接的时候，很多时候就会有这样的需求，我们有一部分链接只想给特定的人或设备访问，那该怎么办呢？无法知道很直观的知晓点击链接人的地区分类，设备分类，等精细化运营的数据，那该怎么办？根据大家的需求我们的高级功能也就应运而生了，在我们的高级功能里有访问密码，地区定位，设备定位，VIP专业报表，替换原网址等以满足各个群体的不同需求。</li>
                    <li>今天我们就来讲解一下，高级功能替换原网址功能说明。（替换原网址后原先的短链接并不更改。）</li>
                  </ol>
                </div>
                <div class="problem-small">
                  1.首先在浏览器中搜索天天短网址www.ttdwz.cc,点击登入。
                </div>
                <div class="problem-img">
                  <img src="../../assets/images/help1.png" style="height: auto;">
                </div>
                <div class="problem-small">
                  2.点击短网址列表，进入列表界面，点击替换。
                </div>
                <div class="problem-img">
                  <img src="https://file1.ttdwz.cc/wm/uploadfile/2019/06/27/bW2tnDKpmx.png">
                </div>
                <div class="problem-small">
                  3.将新的网址粘贴上就可以了。
                </div>
                <div class="problem-img">
                  <img src="https://file1.ttdwz.cc/wm/uploadfile/2019/06/27/6yezdweh83.png">
                </div>
                <div class="problem-small">
                  4.替换原网址到这里就完成了。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="clear"></div>
        <div class="footer ovf">Copyright &copy; 2018-2020  版权所有</div>
    </div>
</template>

<script>
    import Header from "../header";
    export default {
        name: "Help",
      components: {Header},
      data() {
            return {
                demoCodeTabs: 1,
                isVip: false,
                isGuest: true,
                user_info: {},
            }
        },
        mounted() {
            const token = this.$storeLocal.get('token');
            const user_info = this.$storeLocal.get('userInfo');
            const times = Date.parse(new Date())/1000;

            if (token !== null && token !== '' && token !== undefined) {
                if (user_info.expire_date > times){
                    this.isVip = true;
                }
                this.isGuest = false;
                this.user_info = user_info;
            }
            var hash=window.location.hash;
            if(hash){
              this.go_page(hash);
            }
        },
      methods:{
         go_page(index1){
           if (typeof(index1)=='string'){
             index1=index1.replace(/#/g,'');
           }

           window.location='/help#'+index1;
           $('#problem'+index1).css("display","");
           $('#problem'+index1).siblings().css("display","none");
         },
      }
    }
</script>

<style scoped>
table{border-spacing:0}
.app{height:auto;background-color:#ffffff}
.mid{width:1200px;height:auto;margin:0 auto;padding-top:20px}
.mid h2.title{border-left:4px solid #008bff;height:20px;line-height:20px;padding-left:5px;margin:10px 0 20px 0;font-size:22px;font-weight:500}
.apidoc-content{list-style:none;padding-left:40px}
.apidoc-content h3{margin:20px 0 10px 0;color:rgba(0,0,0,0.85);font-weight:500;font-size:18px}
.apidoc-content li.square{list-style:none;margin-left:30px;list-style-type:square}
.web-table a{cursor:pointer}
.web-table table{border-bottom:1px solid #e6e6e6;table-layout:fixed}
.web-table tr th{border-top:1px solid #e6e6e6;padding:16px 5px;color:#333;vertical-align:middle;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;background-color:#f5f5f5;font-weight:normal}
.web-table tr td{border-top:1px solid #e6e6e6;padding:16px 5px;color:#666;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;vertical-align:middle;font-size:14px}
.web-table tr:hover td{background-color:#f2faff}

.ovf{overflow:hidden}
.footer{color:#666666;text-align:center;line-height:114px;margin-top:20px;}

.user-console > .wrap{position: relative;width:1200px;margin:0px auto;  }
.user-console .u-lef{width: 260px;height: 100%;position: absolute;top:0;left: 0;background:#fff;margin-top:20px;border-right: 1px solid #eee;}
.user-console .u-rig{background: #fff;margin-top:20px;width:930px;}
.u-nav:before{content: '';width: 140px;height: 1px;margin: 0 auto;background-color: #ccc;display: block;}
.u-nav:first-child:before{display: none;}
.u-nav:first-child{margin-top: 30px;}
.u-nav{padding-left:10px;}
.u-nav h4{font-size: 22px;font-weight: bold;color: #333;margin-top: 30px;}
.u-nav .nav-list{padding: 20px 0;}
.u-nav .nav-list li{height: 35px;line-height: 35px;overflow: hidden;*display: block;}
.u-nav .nav-list li.hide{display: none;}
.u-nav .nav-list li a{display: block;color: #008DF2;font-size: 0;border-left: 4px solid transparent;}
.u-nav .nav-list li a span{font-size: 14px;display: inline-block;vertical-align: middle;font-weight: bold;}
.u-nav .nav-list li a i{display: inline-block;vertical-align: middle;margin-right: 10px;margin-left: 35px;}

.u-nav .nav-list li a:hover{color: #008df2;}
.u-nav .nav-list li a:hover i{background-position: center bottom;}
.u-nav .nav-list li.on a{color: #008df2;background-color: #edf5fa;border-left-color:#008df2;}
.u-nav .nav-list li.on a i{background-position: center bottom;}

.problem .problem-style{height:auto;}


.problem-img img{width:100%;height:auto;}
</style>
